/* CuteFutures Conversion Fix — Production runtime overrides.
   Loaded only on product templates (theme.liquid conditional). */
(function () {
  'use strict';
  const FREE_SHIP_THRESHOLD = 25;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(() => {
    injectShipBar();
    enhanceBundlePills();
    injectTrust();
    moveLedeBelow();
    injectStickyBuy();
  });

  // ---- 1) FREE SHIPPING PROGRESS BAR ----------------------------------------
  function injectShipBar() {
    const bundleCard = document.querySelector('.cf-bundle-card');
    const sectionHeader = bundleCard?.previousElementSibling;
    if (!bundleCard) return;

    const bar = document.createElement('div');
    bar.className = 'cf-fix-shipbar';
    bar.innerHTML = `
      <div class="cf-fix-shipbar__top">
        <span><span class="cf-fix-shipbar__icon">📦</span> <span id="cf-fix-shipbar-msg"></span></span>
        <span id="cf-fix-shipbar-pct"></span>
      </div>
      <div class="cf-fix-shipbar__track">
        <div class="cf-fix-shipbar__fill" id="cf-fix-shipbar-fill" style="width:0%"></div>
      </div>
    `;
    bundleCard.parentNode.insertBefore(bar, sectionHeader || bundleCard);

    updateShipBar();
  }

  function updateShipBar() {
    const priceEl = document.getElementById('cf-bundle-price');
    if (!priceEl) return;
    const total = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0;
    const remaining = Math.max(0, FREE_SHIP_THRESHOLD - total);
    const pct = Math.min(100, Math.round((total / FREE_SHIP_THRESHOLD) * 100));

    const msg = document.getElementById('cf-fix-shipbar-msg');
    const pctEl = document.getElementById('cf-fix-shipbar-pct');
    const fill = document.getElementById('cf-fix-shipbar-fill');
    if (!msg || !pctEl || !fill) return;

    if (remaining > 0) {
      msg.innerHTML = `Add <strong>$${remaining.toFixed(2)}</strong> for FREE shipping`;
    } else {
      msg.innerHTML = `🎉 You unlocked <strong>FREE shipping</strong>`;
    }
    pctEl.textContent = pct + '%';
    fill.style.width = pct + '%';
  }

  // ---- 2) BUNDLE PILL ENHANCEMENTS ------------------------------------------
  function enhanceBundlePills() {
    const pills = document.querySelectorAll('.cf-bundle__pill');
    const savings = [0, 10, 15, 20];

    pills.forEach((pill, idx) => {
      const qty = parseInt(pill.dataset.qty || pill.textContent.trim(), 10) || (idx + 1);
      pill.setAttribute('data-qty', String(qty));

      const save = savings[qty - 1] || 0;

      if (save > 0 && !pill.querySelector('.cf-fix-pill-save')) {
        const chip = document.createElement('span');
        chip.className = 'cf-fix-pill-save';
        chip.textContent = save + '% off';
        pill.appendChild(chip);
      }
      if (qty === 3 && !pill.querySelector('.cf-fix-pill-best')) {
        const t = document.createElement('span');
        t.className = 'cf-fix-pill-best cf-fix-pill-best--blue';
        t.textContent = 'Popular';
        pill.appendChild(t);
      }
      if (qty === 4 && !pill.querySelector('.cf-fix-pill-best')) {
        const t = document.createElement('span');
        t.className = 'cf-fix-pill-best';
        t.textContent = 'Best value';
        pill.appendChild(t);
      }

      pill.addEventListener('click', () => {
        setTimeout(updateShipBar, 60);
      });
    });
  }

  // ---- 3) TRUST SIGNALS (replaces existing .cf-atc-note line) ---------------
  function injectTrust() {
    const atc = document.querySelector('.cf-atc');
    if (!atc) return;
    const existingNote = atc.parentNode.querySelector('.cf-atc-note');

    const trust = document.createElement('div');
    trust.className = 'cf-fix-trust';
    trust.innerHTML = `
      <span class="cf-fix-trust__item">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#19A067" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        30-day returns
      </span>
      <span class="cf-fix-trust__sep">·</span>
      <span class="cf-fix-trust__item">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#19A067" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        20,000+ customers
      </span>
      <span class="cf-fix-trust__sep">·</span>
      <span class="cf-fix-trust__item">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#19A067" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        Ships in 24h
      </span>
    `;
    if (existingNote) existingNote.replaceWith(trust);
    else atc.parentNode.insertBefore(trust, atc.nextSibling);
  }

  // ---- 4) MOVE LEDE DESCRIPTION BELOW BUY BUTTON (mobile only) --------------
  function moveLedeBelow() {
    if (window.innerWidth > 749) return;
    const lede = document.querySelector('.cf-info__lede');
    const atc = document.querySelector('.cf-atc');
    if (!lede || !atc) return;
    const clone = lede.cloneNode(true);
    clone.classList.add('cf-fix-lede-clone');
    const trust = atc.parentNode.querySelector('.cf-fix-trust');
    const insertAfter = trust?.nextElementSibling || atc.nextElementSibling || atc;
    insertAfter.parentNode.insertBefore(clone, insertAfter.nextSibling);
  }

  // ---- 5) STICKY MOBILE BUY BAR ---------------------------------------------
  function injectStickyBuy() {
    const mainBtn = document.querySelector('.cf-atc') ||
                    document.querySelector('button[name="add"]');
    if (!mainBtn) return;

    const title =
      document.querySelector('.cf-info__title, h1.product__title, h1')?.textContent?.trim() ||
      'Add to cart';

    function readPrice() {
      const p = document.getElementById('cf-bundle-price');
      if (p) return p.textContent.trim();
      const fallback = document.querySelector('.price-item--regular, .price-item');
      return fallback ? fallback.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function readQty() {
      const active = document.querySelector('.cf-bundle__pill.is-active');
      return active?.dataset?.qty || '1';
    }

    const bar = document.createElement('div');
    bar.className = 'cf-fix-stickybuy is-mounted';
    bar.innerHTML = `
      <div class="cf-fix-stickybuy__info">
        <span class="cf-fix-stickybuy__title">${escapeHtml(title)}</span>
        <span class="cf-fix-stickybuy__sub"><span id="cf-fix-sb-qty">${readQty()}</span> &times; <span class="cf-fix-stickybuy__price" id="cf-fix-sb-price">${escapeHtml(readPrice())}</span></span>
      </div>
      <button type="button" class="cf-fix-stickybuy__btn">Add to cart</button>
    `;
    document.body.appendChild(bar);

    bar.querySelector('.cf-fix-stickybuy__btn').addEventListener('click', () => {
      mainBtn.click();
    });

    let hasScrolled = false;
    let mainInView = true;
    const sync = () => {
      if (window.innerWidth >= 750) { bar.classList.remove('is-active'); return; }
      if (hasScrolled && !mainInView) bar.classList.add('is-active');
      else bar.classList.remove('is-active');
    };
    window.addEventListener('scroll', () => {
      if (window.scrollY > 80) hasScrolled = true;
      sync();
    }, { passive: true });

    const io = new IntersectionObserver((entries) => {
      mainInView = entries[0].isIntersecting;
      sync();
    }, { threshold: 0.05 });
    io.observe(mainBtn);

    const priceEl = document.getElementById('cf-bundle-price');
    const refresh = () => {
      const p = document.getElementById('cf-fix-sb-price');
      const q = document.getElementById('cf-fix-sb-qty');
      if (p) p.textContent = readPrice();
      if (q) q.textContent = readQty();
    };
    if (priceEl) new MutationObserver(refresh).observe(priceEl, { childList: true, characterData: true, subtree: true });
    document.querySelectorAll('.cf-bundle__pill').forEach((p) => {
      p.addEventListener('click', () => setTimeout(refresh, 60));
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
})();
